import(/* webpackMode: "eager" */ "/vercel/path0/src/app/auth/layout.tsx");
